export { default } from './PricingWidgetForm';
